// Layouts
import NoBoundLayout from 'Layouts/NoBound/NoBound';
import Login from 'Containers/Auth/Login';

// Authen wrapper
import {
  isUnauthenticatedUser,
} from './helpers/authWrapper';

const routes = [
  {
    path: '/login',
    exact: true,
    ContentComponent: isUnauthenticatedUser(Login),
    Layout: NoBoundLayout,
    bodyClass: 'page-login-appointment',
  },
];

export default routes;
